/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ReadOnlyItemInstance.vue?vue&type=template&id=88d95e6a&scoped=true"
import script from "./ReadOnlyItemInstance.ts?vue&type=script&lang=ts&external"
export * from "./ReadOnlyItemInstance.ts?vue&type=script&lang=ts&external"
import style0 from "./ReadOnlyItemInstance.vue?vue&type=style&index=0&id=88d95e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d95e6a",
  null
  
)

export default component.exports